import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for UAB medical residents with international rotations",
      "Perfect for Regions Bank executives flying to London",
      "Great for Mountain Brook families with upcoming cruises",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Birmingham post offices",
      "Good for planned international trips from BHM",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Birmingham or Hoover USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — ~150 mi, 2.5 hrs drive",
      "NPIC appointment required before traveling to Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function BirminghamProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Birmingham"
      introText="Birmingham travelers — UAB medical residents doing rotations in Central America and Africa, Regions Bank executives flying to Frankfurt and London, Mountain Brook and Vestavia Hills families heading to Cancun and the Caribbean, and Hoover students studying abroad — have several options for getting a passport fast. Here is how they compare, and why most Central Alabama residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Atlanta."
      options={options}
      emergencyDescription="Birmingham does not have its own regional passport agency. The closest is Atlanta — about 150 miles east on I-20, typically 2.5 hours but often longer with Atlanta metro traffic. For a UAB resident with a last-minute conference in Geneva or a Regions executive flying to London next week, that round trip is exhausting. I-20 construction through the Anniston/Oxford corridor adds unpredictable delays."
      disclaimerText="*Processing speed depends on eligibility and documentation. Birmingham does not have a regional passport agency — the closest is Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}